import React from 'react';
import PropTypes from 'prop-types';

import Colors from '../utils/colors';

const Check = ({ className }) => (
  <svg width="32" height="32" viewBox="0 0 36 36" className={className}>
    <g fill="none" fillRule="evenodd">
      <circle cx="18" cy="18" r="18" fill={Colors.primary} />
      <g fill="white">
        <path d="M20.48 21.892l-4.17 4.124-7.656-7.573 4.17-4.124z" />
        <path d="M24.145 10.02l4.17 4.124L16.31 26.016l-4.17-4.124z" />
      </g>
    </g>
  </svg>
);

Check.propTypes = {
  className: PropTypes.string
};

Check.defaultProps = {
  className: ''
};

export default Check;
